<template>
  <Container>
    <h1>Matchs</h1>
    <Match v-for="match in matches" v-bind:key="match.id" :match="match"/>
  </Container>
</template>

<script>
// @ is an alias to /src
import Match from "@/components/Match.vue";
import Container from "@/components/Container.vue";
import axios from "axios";

export default {
  name: "matches",
  computed: {
    matches(){
      return (this.$store.state.matches) ? this.$store.state.matches : [];
    }
  },
  components: {
    Match,
    Container
  }
};
</script>
